import { lazyLoadWithRetry } from "utilities/react.utilities";
import { routes } from "utilities/routes";

import { BTSuspense } from "commonComponents/btWrappers/BTSuspense/BTSuspense";
import { RouteRelative } from "commonComponents/utilities/RouteRelative/RouteRelative";

import { type ICreditMemoProps } from "./CreditMemo";

const CreditMemo = lazyLoadWithRetry(() => import("./CreditMemo"));

export const RouteCreditMemo = (
    props: Omit<ICreditMemoProps, "id" | "jobId" | "history" | "location" | "match">,
) => (
    <RouteRelative
        path={routes.creditMemos.details}
        render={(routeProps) => {
            const id = parseInt(routeProps.match.params.id);
            const jobId = parseInt(routeProps.match.params.jobId);

            return (
                <BTSuspense>
                    <CreditMemo {...props} {...routeProps} id={id} jobId={jobId} />
                </BTSuspense>
            );
        }}
    />
);
